import { createGetPlayerInfoOutbound } from '../../api/outbound/commonOutbounds';
import { maybeOverrideAvatar } from '../../utils/avatarUtils';
import { uuid } from '../../utils/utils';
import { thunkSetActivePanel } from './panelsActions';
import { thunkShowSelfInfo } from './selfDataActions';
export const CLEAR_PLAYER_INFO_STATE = 'CLEAR_PLAYER_INFO_STATE';
export const SET_LOADING_USERNAME = 'SET_LOADING_USERNAME';
export const SET_PLAYER_INFO = 'SET_PLAYER_INFO';
export const UPDATE_PLAYER_BLOCKING_FROM_INBOUND = 'UPDATE_PLAYER_BLOCKING_FROM_INBOUND';
export function clearPlayerInfoState() {
    return {
        type: CLEAR_PLAYER_INFO_STATE
    };
}
function setLoadingUsername(loadingUsername) {
    return {
        type: SET_LOADING_USERNAME,
        payload: loadingUsername
    };
}
function setPlayerInfo(playerInfo) {
    return {
        type: SET_PLAYER_INFO,
        payload: playerInfo
    };
}
export function thunkShowPlayerInfo(playerIdName, socketSend) {
    return function (dispatch, getState) {
        const state = getState();
        const myPlayerId = state.selfData.id;
        if (myPlayerId === playerIdName.id) {
            dispatch(thunkShowSelfInfo(socketSend));
            dispatch(thunkSetActivePanel('self', socketSend));
        }
        else {
            dispatch(clearPlayerInfoState());
            dispatch(setLoadingUsername(playerIdName.name));
            dispatch(thunkSetActivePanel('playerInfo', socketSend));
            socketSend(createGetPlayerInfoOutbound(playerIdName.id));
        }
    };
}
export function thunkShowPlayerInfoFromInbound(inbound) {
    return function (dispatch, getState) {
        const state = getState();
        const currentRoomSceneType = state.scene.roomSceneType;
        if (!currentRoomSceneType) {
            throw new Error("Can't show player info when not in a room scene type");
        }
        const defaultPlayerAvatar = inbound.avatarPropertiesSet
            ? { type: 'custom', avatar: inbound.avatarPropertiesSet, uuid: uuid() }
            : undefined;
        const playerAvatar = maybeOverrideAvatar(inbound.playerIdName.id, inbound.playerIdName.name, defaultPlayerAvatar);
        const playerInfo = {
            playerIdName: inbound.playerIdName,
            isPowerPlayer: inbound.isPowerPlayer,
            numChipsInBank: inbound.numChipsInBank,
            playerAvatar,
            medals: inbound.medals,
            blockingTypes: inbound.blockingTypes,
            playerStyle: inbound.playerStyle,
            bio: inbound.bio,
            statsFields: inbound.statsFields,
            restrictedStatsFields: inbound.restrictedStatsFields
        };
        dispatch(setPlayerInfo(playerInfo));
    };
}
export function updatePlayerBlockingFromInbound(inbound) {
    return {
        type: UPDATE_PLAYER_BLOCKING_FROM_INBOUND,
        payload: inbound
    };
}
